import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"
import isNumber from "lodash-es/isNumber"

import { axiosClient } from "$/http"

import { extractNumberFromQueryKeyPart } from "@/3514/utils"

import {
    ECoachGroupParticipantQueryKey as EKey,
    ECoachGroupParticipantQueryUrl as EUrl
} from "./coach.group-participant.api.config"
import type { ICoachGroupParticipantModuleByIdQueryDto as IDto } from "./coach.group-participant.api.types"

export default {
    async moduleById({ queryKey }: QueryFunctionContext<ReturnType<typeof EKey.ModuleById>>): Promise<IDto> {
        const moduleId: number = extractNumberFromQueryKeyPart(queryKey[3])

        if (!isNumber(moduleId) || moduleId === -1) throw new Error("moduleId must be number")

        const { data }: AxiosResponse<IDto> = await axiosClient.get<IDto>(
            EUrl.ModuleById({
                participantId: extractNumberFromQueryKeyPart(queryKey[2]),
                moduleId
            })
        )

        return data
    }
}
